/* Very standard JS spaghetti code */
import Swiper from "swiper";
import {
	Navigation,
	Pagination,
	EffectFade,
	Controller,
	Keyboard,
} from "swiper/modules";
import "swiper/swiper-bundle.css";
import {listen} from "./quicklink.umd.js";

import {animate, inView, cubicBezier, stagger} from "motion/dist/motion.js";
const easeOutExpo = cubicBezier(0.35, 0.75, 0.5, 1);

/* Quicklink */
window.addEventListener("load", () => {
	listen();
});

/* Load functions */
document.addEventListener("DOMContentLoaded", () => {
	//reducedMotion();
	//toggleReducedMotion(); // Manual toggle of animations
	toggleOverlays((duration = 0.6));
	loadSlides();
	lazyLoadVideos();
	addImageSize();
	setupResizeListener(addImageSize);
	navbar();
	//customCursor();
	//moveImage();
	if (localStorage.getItem("reduced-motion") !== "true") {
		detailsAccordionAnimation();
		pageFadeTransition(400);
		setupScrollAnimations();
	} else {
		pageFadeTransition(800); // Slows down fade effect
	}
});

/* Helper functions */
function setItemWithExpiry(key, value, ttl) {
	const now = new Date();

	const item = {
		value: value,
		expiry: Math.round(now.getTime() / 1000) + ttl,
	};

	localStorage.setItem(key, JSON.stringify(item));
}

function getItemWithExpiry(key) {
	const itemStr = localStorage.getItem(key);
	const item = JSON.parse(itemStr);
	const now = new Date();

	if (!itemStr) {
		return null;
	}

	if (Math.round(now.getTime() / 1000) > item.expiry) {
		localStorage.removeItem(key);
		return null;
	}

	return Math.round((item.expiry - now.getTime() / 1000) / 60);
}

// Resize listener setup with viewport change filtering
function setupResizeListener(callback, delay = 100) {
	let resizeTimeout;
	let prevWidth = window.innerWidth;
	let prevHeight = window.innerHeight;

	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout); // Debounce the resize event
		resizeTimeout = setTimeout(() => {
			const currentWidth = window.innerWidth;
			const currentHeight = window.innerHeight;

			// Determine if resize is significant
			const isWidthChanged = currentWidth !== prevWidth;
			const isHeightSignificant =
				Math.abs(currentHeight - prevHeight) > 50;

			if (isWidthChanged || isHeightSignificant) {
				// Call the provided callback only on significant changes
				callback();

				// Update the stored dimensions
				prevWidth = currentWidth;
				prevHeight = currentHeight;
			}
		}, delay);
	});
}

// Check the reduced-motion preference and set localy
function reducedMotion() {
	const reducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)"
	).matches;

	localStorage.setItem("reduced-motion", reducedMotion);
}

// Manual toggle off animations
function toggleMotion() {
	const button = document.getElementById("toggle-reduced-motion");
	const manualReducedMotion = localStorage.getItem("manual-reduced-motion");

	button?.addEventListener("click", (event) => {
		localStorage.setItem("manual-reduced-motion", newState);
	});
}

function filterCase() {
	const filterContainer = document.querySelector("#filterContainer");
	if (!filterContainer) {
		console.log("filterContainer not found");
		return;
	}

	const filterButtons = document.querySelectorAll("button[data-filter]");
	const clearButton = filterButtons[0];
	const links = filterContainer?.querySelectorAll("article");

	let activeFilters = new Set();

	function filterLinks() {
		const activeFiltersArray = Array.from(activeFilters);

		links?.forEach((link) => {
			const linkCategories = link.dataset.filter.split(",");
			let showLink = false;

			if (activeFilters.size === 0) {
				showLink = true;
			} else {
				showLink = activeFiltersArray.every((filter) =>
					linkCategories.includes(filter)
				);
			}

			if (showLink) {
				link.classList.remove("hidden");
			} else {
				link.classList.add("hidden");
			}
		});

		updateURL();
	}

	function updateURL() {
		const urlParams = new URLSearchParams(); // Create a new URLSearchParams object

		if (activeFilters.size > 0) {
			activeFilters.forEach((filter) => {
				urlParams.append("filter", filter); // Use append to add multiple filters
			});
		}

		const newURL = `${window.location.pathname}${urlParams.toString() ? "?" + urlParams.toString() : ""}`;
		window.history.replaceState(null, null, newURL);
	}

	function handleURLParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const filtersFromURL = urlParams.getAll("filter"); // Use getAll to get all filter values

		filtersFromURL.forEach((filter) => {
			activeFilters.add(filter);
		});
	}

	// 1. Handle URL parameters *first*
	handleURLParams();

	// 2. Attach event listeners *after* handling URL parameters
	filterButtons?.forEach((button) => {
		button.addEventListener("click", () => {
			const filter = button.dataset.filter;

			if (button === clearButton) {
				activeFilters.clear();
				filterButtons.forEach((btn) => btn.classList.remove("active"));
				button.classList.add("active");
			} else {
				clearButton.classList.remove("active");
				if (activeFilters.has(filter)) {
					activeFilters.delete(filter);
					button.classList.remove("active");
				} else {
					activeFilters.add(filter);
					button.classList.add("active");
				}
			}

			if (activeFilters.size === 0) {
				clearButton.classList.add("active");
			}

			filterLinks();
		});
	});

	// 3. Perform initial filtering *after* attaching event listeners and setting activeFilters
	filterLinks();

	// 4. Set active button styles after the initial filter
	activeFilters.forEach((filter) => {
		const button = document.querySelector(`[data-filter="${filter}"]`);
		if (button) {
			button.classList.add("active");
			clearButton.classList.remove("active");
		}
	});
}

/* Needs update? */
function toggleOverlays(duration) {
	const hamburgerButton = document.getElementById("hamburgerButton");
	const openIcon = hamburgerButton.querySelector('img[alt="Meny ikon"]');
	const closeIcon = hamburgerButton.querySelector('img[alt="Stäng ikon"]');
	const menuTakeover = document.getElementById("menuTakeover");
	const backdrop = document.getElementById("backdropOverlay");
	const focusableElements = menuTakeover.querySelectorAll(
		"a, button, input, [tabindex]"
	);

	// Initialize focus state
	const setFocusable = (enabled) => {
		focusableElements.forEach((el) => {
			el.tabIndex = enabled ? 0 : -1;
		});

		if (enabled) {
			menuTakeover.removeAttribute("inert");
			menuTakeover.setAttribute("aria-hidden", "false");
		} else {
			menuTakeover.setAttribute("inert", "");
			menuTakeover.setAttribute("aria-hidden", "true");
		}
	};

	setFocusable(false); // Disable focus initially

	const motionOpenMenu = [
		[menuTakeover, {left: ["100%", "0%"]}, {ease: easeOutExpo}],
		[backdrop, {opacity: [0, 1]}, {at: 0}, {duration: 0.3}],
	];
	const motionCloseMenu = [
		[menuTakeover, {left: ["0%", "100%"]}, {ease: easeOutExpo}],
		[backdrop, {opacity: [1, 0]}, {at: 0}, {duration: 0.3}],
	];

	const isMenuOpen = false;

	const toggleMenu = () => {
		if (!isMenuOpen) {
			const openMenu = animate(motionOpenMenu, {
				defaultTransition: {duration: duration, ease: easeOutExpo},
			});
			openMenu.then(() => {
				setFocusable(true);
			});
		} else {
			const closeMenu = animate(motionCloseMenu, {
				defaultTransition: {duration: duration, ease: easeOutExpo},
			});
			closeMenu.then(() => {
				setFocusable(false);
				hamburgerButton.focus(); // Move focus back to the hamburger button
			});
		}
		isMenuOpen = !isMenuOpen;
	};

	const toggleMenuIcon = () => {
		openIcon.classList.toggle("hidden");
		closeIcon.classList.toggle("hidden");
	};

	hamburgerButton?.addEventListener("click", () => {
		toggleMenu();
		toggleMenuIcon();
	});
}

function navbar() {
	/* Fixa accesibility */
	const staticMenu = document.getElementById("staticMenu");
	const fixedMenu = document.getElementById("fixedMenu");

	inView(staticMenu, (element, enterInfo) => {
		hideNavbar(fixedMenu);
		return (leaveInfo) => showNavbar(fixedMenu);
	});

	function hideNavbar(element) {
		if (!element) {
			console.warn("navbar not found");
			return;
		}
		//element.style.transform = "none";
		animate(element, {y: [0, -120]}, {duration: 0.5, ease: easeOutExpo});
	}

	function showNavbar(element) {
		if (!element) {
			console.warn("navbar not found");
			return;
		}
		//element.style.transform = "none";
		animate(element, {y: [-120, 0]}, {duration: 0.5, ease: easeOutExpo});
	}
}

/* Basic Page-Transition with bfcache Fix */
function pageFadeTransition(fadeInMs) {
	const loader = document.getElementById("loader");

	if (!loader) return;

	loader.style.transitionDuration = fadeInMs + "ms";

	// Handle initial page load and bfcache
	window.addEventListener("pageshow", (event) => {
		if (!event.persisted) {
			console.log("Returning visitor c:");
			setTimeout(() => {
				hideLoader(fadeInMs); // Delay for hiding fixed navbar –– Should probably fix
			}, 150);
		} else {
			console.warn("bfcache");
			setTimeout(() => {
				hideLoader(fadeInMs);
			}, 150);
		}
	});

	// Transition out the page on link click
	document.querySelectorAll("a").forEach((link) => {
		if (link.hostname === window.location.hostname) {
			link.addEventListener("click", function (event) {
				const linkHref = link.href;
				const currentHref = window.location.href;

				// Check for download or same-page hash links
				if (
					link.hasAttribute("download") ||
					link.hasAttribute("data-fancybox") ||
					(linkHref.split("#")[0] === currentHref.split("#")[0] &&
						linkHref.includes("#"))
				) {
					return; // Ignore these links
				}

				event.preventDefault();

				loader.style.visibility = "visible";
				loader.classList.remove("!opacity-0");

				setTimeout(() => {
					window.location = linkHref;
				}, fadeInMs);
			});
		}
	});

	function hideLoader(delay) {
		setTimeout(() => {
			loader.classList.add("!opacity-0");
			setTimeout(() => {
				loader.style.visibility = "hidden";
			}, delay);
		}, 25);
	}
}

/* Add sizes="" value to all images, seems to not impact image selection for picture elements but does clear lighthouse warning atleast */
function addImageSize() {
	const pictures = document.querySelectorAll("picture");
	const images = Array.from(document.querySelectorAll("img")).filter(
		(img) => {
			return !img.parentElement.querySelector("source");
		}
	);
	if (pictures.length === 0 || images.length === 0) return;

	pictures?.forEach((picture) => {
		const img = picture.querySelector("img");
		const sources = picture.querySelectorAll("source");

		if (img.length === 0) return;
		const displayedWidth = img.clientWidth;
		const displayedHeight = img.clientHeight;

		img.setAttribute("sizes", `${displayedWidth}px`);
		img.setAttribute("width", `${displayedWidth}`);
		img.setAttribute("height", `${displayedHeight}`);

		sources?.forEach((source) => {
			source.setAttribute("sizes", `${displayedWidth}px`);
			const srcset = source.getAttribute("srcset");
		});
	});

	images?.forEach((img) => {
		const displayedWidth = img.clientWidth;
		const displayedHeight = img.clientHeight;

		img.setAttribute("sizes", `${displayedWidth}px`);
		img.setAttribute("width", `${displayedWidth}`);
		img.setAttribute("height", `${displayedHeight}`);
	});
}
// Lazy load videos
function lazyLoadVideos() {
	const lazyVideoElements = document.querySelectorAll(
		"video[data-desktop-src]"
	);
	if (!lazyVideoElements.length) return;

	if (!("IntersectionObserver" in window)) return; // Early exit if no observer

	const lazyVideoObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return; // Skip if not intersecting

				const video = entry.target;
				handleResponsiveVideoSource(video);
				if (video.hasAttribute("pausable")) {
					setTimeout(() => setupVideoPauseButton(video), 50);
				}
				lazyVideoObserver.unobserve(video); // Stop observing once loaded
			});
		},
		{rootMargin: "0px 0px 200px 0px"}
	);

	lazyVideoElements?.forEach((video) => lazyVideoObserver.observe(video));

	window.addEventListener("resize", () => {
		lazyVideoElements.forEach(handleResponsiveVideoSource);
	});
}

// Handle responsive video sources
function handleResponsiveVideoSource(video) {
	const videoSource = video.querySelector("source");
	const desktopSrc = video.getAttribute("data-desktop-src");
	const mobileSrc = video.getAttribute("data-mobile-src");
	const breakpoint = 768;
	const isMobile = window.innerWidth < breakpoint;
	const newSrc = isMobile && mobileSrc ? mobileSrc : desktopSrc;

	if (videoSource.dataset.src !== newSrc) {
		const wasPaused =
			sessionStorage.getItem(`videoPaused-${video.id}`) === "true";

		videoSource.dataset.src = newSrc;
		videoSource.src = newSrc;
		video.load();

		if (wasPaused) {
			video.pause();
		}
	}
}

// Set up video pause button functionality
function setupVideoPauseButton(video) {
	const button = video.closest(".video-wrapper")?.querySelector("button");
	if (button.length === 0) return;

	const playIcon = button.querySelector('img[alt="play video"]');
	const pauseIcon = button.querySelector('img[alt="pause video"]');
	const reducedMotion = localStorage.getItem("reduced-motion") === "true";
	let videoPaused =
		sessionStorage.getItem(`videoPaused-${video.id}`) === "true";

	// Initial pause for reduced-motion users
	if (reducedMotion) {
		video.currentTime = 1;
		video.pause();
		videoPaused = true;
	} else if (!videoPaused) {
		video.play();
	}

	// Sync UI state
	playIcon.classList.toggle("hidden", !videoPaused);
	pauseIcon.classList.toggle("hidden", videoPaused);

	button?.addEventListener("click", () => {
		if (videoPaused) {
			video.play();
			sessionStorage.setItem(`videoPaused-${video.id}`, "false");
		} else {
			video.pause();
			sessionStorage.setItem(`videoPaused-${video.id}`, "true");
		}
		videoPaused = !videoPaused;
		playIcon.classList.toggle("hidden", !videoPaused);
		pauseIcon.classList.toggle("hidden", videoPaused);
	});

	function setButtonWrapperHeight() {
		const buttonWrapper = button?.closest("div");
		const mediaWrapper = video
			.closest(".video-wrapper")
			?.querySelector("figure");
		console.log(mediaWrapper.offsetHeight);

		const mediaHeight = mediaWrapper?.clientHeight;

		buttonWrapper.style.height = mediaHeight + "px";
	}

	setupResizeListener(setButtonWrapperHeight);
	setButtonWrapperHeight();
}

function loadSlides() {
	const objectGallery = new Swiper(".gallery-hero", {
		modules: [Navigation, Pagination, EffectFade, Controller, Keyboard],
		loop: true,
		slidesPerView: 1,
		effect: "fade",
		grabCursor: true,
		fadeEffect: {
			crossFade: true,
		},
		keyboard: {
			enabled: true,
		},
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
			renderFraction: function (currentClass, totalClass) {
				return (
					'<span class="' +
					currentClass +
					'"></span>' +
					" av " +
					'<span class="' +
					totalClass +
					'"></span>'
				);
			},
		},
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
	});

	const objectLightboxGallery = new Swiper(".gallery-lightbox", {
		modules: [Navigation, Pagination, EffectFade, Controller],
		loop: true,
		slidesPerView: 1,
		effect: "fade",
		grabCursor: true,
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
			renderFraction: function (currentClass, totalClass) {
				return (
					'<span class="' +
					currentClass +
					'"></span>' +
					" av " +
					'<span class="' +
					totalClass +
					'"></span>'
				);
			},
		},
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
	});

	if (objectLightboxGallery && objectGallery) {
		objectGallery.controller.control = objectLightboxGallery;
		objectLightboxGallery.controller.control = objectGallery;
	}

	const galleryAuto = new Swiper(".gallery-auto", {
		modules: [Navigation, Keyboard],
		loop: false,
		slidesPerView: "auto",
		spaceBetween: 24,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
	});

	const galleryFullWidth = new Swiper(".gallery-full", {
		modules: [Navigation, Pagination, EffectFade, Keyboard],
		loop: true,
		slidesPerView: 1,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		keyboard: {
			enabled: true,
		},
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
			renderFraction: function (currentClass, totalClass) {
				return (
					'<span class="' +
					currentClass +
					'"></span>' +
					" av " +
					'<span class="' +
					totalClass +
					'"></span>'
				);
			},
		},
		navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		},
	});
}

function detailsAccordionAnimation() {
	document.querySelectorAll("details").forEach((detail) => {
		const title = detail.querySelector("summary") ?? null;
		const content = detail.querySelector("div");

		if (!content) return; // Ensure content element exists
		content.style.height = "0px"; // Initialize content height to 0

		title?.addEventListener("click", (event) => {
			event.preventDefault();

			const groupName = detail.getAttribute("name");

			if (detail.open) {
				// Close the current detail
				const close = animate(
					content,
					{height: 0},
					{duration: 0.2, ease: easeOutExpo}
				);
				close.then(() => {
					detail.open = false;
				});
			} else {
				if (groupName) {
					// Close other details in the same group
					document
						.querySelectorAll(`details[name="${groupName}"]`)
						.forEach((otherDetail) => {
							if (otherDetail !== detail && otherDetail.open) {
								const otherContent =
									otherDetail.querySelector("div");
								if (otherContent) {
									animate(
										otherContent,
										{height: 0},
										{duration: 0.2, ease: easeOutExpo}
									).then(() => {
										otherDetail.open = false;
									});
								}
							}
						});
				}

				// Open the current detail
				detail.open = true;
				const open = animate(
					content,
					{height: "auto"},
					{duration: 0.3, ease: easeOutExpo}
				);
				open.then(() => {
					//console.log("details-opened"); // Reset animate(Scroll)??
				});
			}
		});
	});
}

function setupScrollAnimations() {
	function handleFadeElements() {
		const fadeElements = document.querySelectorAll(
			'[data-animation="fade"]'
		);
		if (fadeElements.length === 0) return;

		fadeElements.forEach((element) => {
			inView(element, () => {
				animate(
					element,
					{opacity: [0, 1]},
					{
						duration: 1,
						ease: easeOutExpo,
					}
				);
			});
		});
	}

	function handleBlobElements() {
		const textBlobs = document.querySelectorAll('[data-animation="blob"]');
		if (textBlobs.length === 0) return;

		textBlobs.forEach((element) => {
			inView(element, () => {
				animate(
					element,
					{scale: [0, 1]},
					{
						duration: 0.6,
						ease: easeOutExpo,
					}
				);
			});
		});
	}

	// Call both functions
	handleFadeElements();
	handleBlobElements();
}
